<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-box">&nbsp; Stock</h5>
        </div>
        <div class="col-auto text-center p-0" v-if="$store.getters.isSuper">
          <button class="btn btn-primary w-100 bi-hammer" @click="fixStock()" :disabled="loading">&nbsp; Fix Stock</button>
        </div>
        <div class="col-auto text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadStocks()" :disabled="loading">&nbsp; Reload</button>
        </div>
        <div class="col-auto p-0">
          <button class="btn w-100 btn-success bi-file-earmark-excel-fill" @click="xlsx()" :disabled="loading">&nbsp; Excel</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->          
      <div class="row p-0">

        <div class="col p-0">
          <div class="input-group w-100">
            <span class="input-group-text bi-search"></span>
            <input class="form-control" type="text" placeholder="Search by name" v-model.trim='filter'>
          </div>
        </div>
        
        <div class="col p-0">
        </div>
        <div class="col p-0">
        </div>
        
        <div class="col p-0">
          <div class="input-group w-100">
            <span class="input-group-text w-25">Branch</span>
            <select class="form-select" v-model="currBranch" @change="branchChanged()" :disabled="loading">
              <option value="*">All Branches</option>
              <option v-for="b in access_stock" :key="b._id" :value="b._id">{{ b.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="w-15">Brand</th>
          <th class="w-15">Size</th>
          <th class="w-15">Pattern</th>
          <th class="">barcode</th>
          <th class="w-15 text-center">Quantity</th>
          <th class="w-10 text-center">DoA</th>
          <th class="text-center w-50px"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="tire in tires_filtered" :key="tire._id">
          <td class="w-15">{{ tire.brand }}</td>
          <td class="w-15">{{ tire.size }}</td>
          <td class="w-15">{{ tire.pattern }}</td>
          <td class="">{{ tire.barcode }}</td>
          <td class="w-15 text-center" v-bind:class="tire.quantity == 0 ? 'table-danger' : ''">{{ tire.quantity }}</td>
          <td class="w-10 text-center">{{ tire.doa }}</td>
          <td class="dropstart text-center w-50px">
            <a data-bs-toggle='dropdown' class="btn btn-sm btn-secondary p-1"><span class="bi-three-dots-vertical"></span></a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item bi-eye" @click="showStockDetails(tire)">Details</a></li>
              <li v-if="$store.getters.access('stock_supply')"><a class="dropdown-item bi-box-arrow-in-down" @click="showSupply(tire)">Supply</a></li>
              <li v-if="$store.getters.access('stock_return')"><a class="dropdown-item bi-arrow-counterclockwise" @click="showReturn(tire)">Return</a></li>
              <li v-if="$store.getters.isSuper"><a class="dropdown-item bi-hammer text-primary" @click="showChange(tire)">Change</a></li>
            </ul>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <div id="stockDetails" ref="stockDetails" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Stock: {{ stockDetails.productName }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <!-- <div v-if="currBranch == '*'" id="stockDetailsPieChartContainer">
              <canvas ref="stockDetailsPieChart" width='400' height='400'></canvas>
            </div> -->
            <DoughnutChart v-if="currBranch == '*'" :chartData="DoughnutChartData" :options="DoughnutChartOptions"/>

            <table class="table table-sm table-striped table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th>Branch</th>
                  <th>Prod Date</th>
                  <th class="text-center">Quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x in stockDetails.quantities" :key="x._id">
                  <th>{{ x.branch }}</th>
                  <th>{{ x.prod_date }}</th>
                  <th>{{ x.quantity }}</th>
                </tr>
                <tr class="table-secondary">
                  <th colspan="2">Total</th>
                  <th>{{ totalStockDetails }}</th>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Close</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="fetchStockDetails()">Reload</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="supplyModal" ref="supplyModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Supply {{ supply.productName }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Branch</span>
              <select class="form-select" v-model="supply.branch">
                <option v-for="b in branches" :key="b._id" :value="b._id">{{ b.name }}</option>
              </select>
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Amount</span>
              <input class="form-control" type="number" v-model.number="supply.amount">
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-50">Production Date</span>
              <input class="form-control" type="text" v-model="supply.prod_date" @input="validProdDate($event)">
              <div class="form-text bg-warning-subtle bi-exclamation-triangle-fill w-100">
                &nbsp; Production date format: Week 01-53, Year 19-99, example: 1924
              </div>
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">
                <span>Notes</span>
                <span class="badge.bg-secondary"></span>
              </span>
              <textarea class="form-control" rows="8" type="number" v-model.trim="supply.notes"></textarea>
            </div>

          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="supplyAction()">
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Supply</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="returnModal" ref="returnModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Return {{ returnOrder.productName }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Branch</span>
              <select class="form-select" v-model="returnOrder.branch" @change="branchChangedReturnOrder()">
                <option v-for="b in branches" :key="b._id" :value="b._id">{{ b.name }}</option>
              </select>
            </div>
            
            <table class="table table-sm table-striped table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th>Branch</th>
                  <th>Prod Date</th>
                  <th class="text-center">Quantity</th>
                </tr>
              </thead>
              <tbody>
                <LoadingRow v-if="loading"></LoadingRow>
                <tr v-for="x in returnOrder.quantities" :key="x._id">
                  <th>{{ x.branch }}</th>
                  <th>{{ x.prod_date }}</th>
                  <th>{{ x.quantity }}</th>
                </tr>
              </tbody>
            </table>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-50">Production Date</span>
              <select class="form-select" v-model="returnOrder.prod_date">
                <option v-for="x in returnOrder.quantities" :key="x._id" :value="x.prod_date">{{ x.prod_date }}</option>
              </select>
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Amount</span>
              <input class="form-control" type="number" v-model.number="returnOrder.amount">
            </div>


            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">
                <span>Notes</span>
                <span class="badge.bg-secondary"></span>
              </span>
              <textarea class="form-control" rows="4" type="number" v-model.trim="returnOrder.notes"></textarea>
            </div>

          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="returnAction()">
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Return</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="changeModal" ref="returnModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Change {{ changeOrder.productName }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Branch</span>
              <select class="form-select" v-model="changeOrder.branch" @change="branchChangedChangeOrder()">
                <option v-for="b in branches" :key="b._id" :value="b._id">{{ b.name }}</option>
              </select>
            </div>
            
            <table class="table table-sm table-striped table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th>Branch</th>
                  <th>Prod Date</th>
                  <th class="text-center">Quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x in changeOrder.quantities" :key="x._id">
                  <th>{{ x.branch }}</th>
                  <th>{{ x.prod_date }}</th>
                  <th>{{ x.quantity }}</th>
                </tr>
              </tbody>
            </table>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-50">Production Date</span>
              <input class="form-control" type="text" v-model="changeOrder.prod_date" @input="validProdDate($event)">
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Amount</span>
              <input class="form-control" type="number" v-model.number="changeOrder.amount">
            </div>


          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="changeAction()">Change</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
  </div>
</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  import { DoughnutChart } from 'vue-chart-3';
  import { Chart, registerables } from "chart.js";
  Chart.register(...registerables);
  export default {
    name: 'StockPage',
    components: { DoughnutChart },
    data(){
      return {
        loading: false,
        
        branches: [],
        access_stock: [],
        currBranch: '',
        
        tires: [],
        filter: '',
        //----------------------------------
        changeOrder:{
          branch: '',
          poduct: '',
          productName: '',
          amount: 0,
          quantities: [],
        },
        //----------------------------------
        returnOrder:{
          branch: '',
          poduct: '',
          productName: '',
          notes: '',
          amount: 0,
          quantities: [],
        },
        //----------------------------------
        supply:{
          branch: '',
          poduct: '',
          productName: '',
          prod_date: '',
          notes: '',
          amount: 0,
        },
        //----------------------------------
        stockDetails: {
          tire_id: '',
          productName: '',
          quantities: [],
        },
        //----------------------------------
        DoughnutChartData: {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: ['#36a2eb', '#ff6384', '#4bc0c0', '#ff9f40', '#9966ff', '#ffcd56', '#c9cbcf'],
          }],
        },
        DoughnutChartOptions: {   
          responsive: true, maintainAspectRatio: false,
          aspectRatio: 1, layout: { padding: 10 },
          plugins: { 
            colors: { enabled: true },
            legend: { display: true, position: 'right', labels: { font: { size: 20 } } },
          },
        }

      }
    },
    async created() {
      await this.loadBranches();
      if(this.branches.length == 1) this.currBranch = this.branches[0]._id;
      if(this.branches.length > 1) this.currBranch = '*';
      await this.loadStocks();
      var code = "", reading = false;
      document.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
            if(code.length >= 8) {
              this.onBarcodeScan(code);
              code = "";
            }
        }
        else { code += e.key; }
        if(!reading) {
            reading = true;
            setTimeout(() => { code = ""; reading = false;}, 200);
        }
      });
    },
    //**********************************************************
    computed:{
      tires_filtered(){
        let filter = this.filter.toLowerCase();
        return this.tires.filter((x)=>{
          if(x.barcode && x.barcode.toLowerCase().includes(filter)) return true;
          if(x.brand && x.brand.toLowerCase().includes(filter)) return true;
          if(x.size && x.size.toLowerCase().includes(filter)) return true;
          if(x.pattern && x.pattern.toLowerCase().includes(filter)) return true;
          return false;
        });
      },
      totalStockDetails(){
        return this.stockDetails.quantities.reduce((acc, x)=> acc + x.quantity, 0);
      }
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadBranches(){
        this.loading = true;
        this.branches = [];
        this.access_stock = [];
        var ack = await this.$service.getBranchesAbstractV2();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.branches = ack.data.branches;
          this.access_stock = ack.data.access_stock;
        }
        this.loading = false;
      },
      //**********************************************************
      async loadStocks(){
        this.loading = true;
        this.tires = [];
        var ack = await this.$service.getStocks({ branch: this.currBranch });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.tires = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async fixStock(){
        this.loading = true;
        var ack = await this.$service.fixStock();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast(`Stock Fixed: ${ack.data.modified}/${ack.data.matched}`, 'success');
        }
        this.loading = false;
      },
      //**********************************************************
      async xlsx(){
        this.loading = true;
        
        var ack = await this.$service.getStocks({ 
          branch: this.currBranch,
          xlsx: true
        }, 'blob');
        if(!ack){
          this.$toast('Error');
        }
        else{
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(ack.blob);
          link.download = ack.fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        
        this.loading = false;
      },

      //**********************************************************
      async showSupply(tire){
        this.loading = true;
        var valid = this.branches.findIndex((x)=>x._id == this.currBranch);
        if(valid < 0) this.currBranch = this.branches[0]._id;
        this.supply.branch = this.currBranch == "*" ? '' : this.currBranch;
        this.supply.product = tire._id;
        this.supply.productName = `${tire.brand} ${tire.size} ${tire.pattern}`;
        this.supply.amount = 0;
        this.supply.prod_date = '';
        this.supply.notes = '';
        this.loading = false;
        $('#supplyModal').modal('show');
      },
      //**********************************************************
      async onBarcodeScan(code){
        this.filter = code;
      },
      //**********************************************************
      async supplyAction(){
        this.loading = true;
        await this._supplyAction();
        this.loading = false;
      },
      //**********************************************************
      async _supplyAction(){
        if(!this.supply.branch){
          return this.$toast('Select a branch', 'warning');
        }
        if(!this.supply.prod_date){
          return this.$toast('write a production date', 'warning');
        }
        this.supply.prod_date = this.supply.prod_date.toString();
        if(this.supply.prod_date.length != 4){
          return this.$toast('invalid production date', 'warning');
        }
        if(this.supply.amount < 1){
          return this.$toast('invalid amount', 'warning');
        }
        if(!this.supply.product){
          return this.$toast('select a product', 'warning');
        }
        var ack = await this.$service.supply({
          branch: this.supply.branch,
          product: this.supply.product,
          prod_date: this.supply.prod_date.toString(),
          amount: parseInt(this.supply.amount),
          notes: this.supply.notes,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#supplyModal').modal('hide');
        this.$toast('Amount Supplied', 'success');
        this.loadStocks();
      },
      //**********************************************************
      async branchChanged(){
        this.loadStocks();
      },
      //**********************************************************
      async fetchStockDetails(){
        this.loading = true;

        this.stockDetails.quantities = [];
        var ack = await this.$service.getStockDetails({
          branch: this.currBranch,
          product: this.stockDetails.tire_id,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
          this.loading = false;
          return;
        }
        this.stockDetails.quantities = ack.data;
        if(this.currBranch == '*'){
          var total = this.access_stock.reduce((acc, x)=>{ acc[x.name] = 0; return acc;}, {});
          this.stockDetails.quantities.forEach((x)=>total[x.branch] += x.quantity);
          console.log(total);
          this.DoughnutChartData.labels = Object.entries(total).map(([k, v])=>`${k} ${v}`);
          this.DoughnutChartData.datasets[0].data = Object.values(total);
        }
        this.loading = false;
      },
      async showStockDetails(tire){      
        this.stockDetails.productName = `${tire.brand} ${tire.size} ${tire.pattern}`;
        this.stockDetails.tire_id = tire._id;
        await this.fetchStockDetails();
        $('#stockDetails').modal('show');
      },
      //**********************************************************
      async showReturn(tire){
        this.loading = true;
        var valid = this.branches.findIndex((x)=>x._id == this.currBranch);
        if(valid < 0) this.currBranch = this.branches[0]._id;
        this.returnOrder.branch = this.currBranch == "*" ? this.branches[0]._id : this.currBranch;
        this.returnOrder.product = tire._id;
        this.returnOrder.productName = `${tire.brand} ${tire.size} ${tire.pattern}`;
        this.returnOrder.amount = 0;
        this.returnOrder.prod_date = '';
        this.returnOrder.notes = '';
        this.loading = false;
        $('#returnModal').modal('show');
        this.branchChangedReturnOrder();
      },
      //**********************************************************
      async branchChangedReturnOrder(){
        this.loading = true;
        this.returnOrder.quantities = [];
        var ack = await this.$service.getStockDetails({
          branch: this.returnOrder.branch,
          product: this.returnOrder.product,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.returnOrder.quantities = ack.data;
          this.returnOrder.prod_date = ''
          this.returnOrder.amount = 0;
          this.returnOrder.notes = '';
          if(this.returnOrder.quantities.length){
            this.returnOrder.prod_date = this.returnOrder.quantities[0].prod_date;
          }
        }
        this.loading = false;
      },
      //**********************************************************
      async returnAction(){
        this.loading = true;
        await this._returnAction();
        this.loading = false;
      },
      //**********************************************************
      async _returnAction(){
        if(!this.returnOrder.branch){
          return this.$toast('Select a branch', 'warning');
        }
        if(!this.returnOrder.prod_date){
          return this.$toast('Select a production date', 'warning');
        }
        if(this.returnOrder.amount < 1){
          return this.$toast('invalid amount', 'warning');
        }
        var ack = await this.$service.return({
          branch: this.returnOrder.branch,
          product: this.returnOrder.product,
          prod_date: this.returnOrder.prod_date,
          notes: this.returnOrder.notes,
          amount: parseInt(this.returnOrder.amount),
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#returnModal').modal('hide');
        this.$toast('Amount Returned', 'success');
        this.loadStocks();
      },
      //**********************************************************
      async validProdDate(event){
        if(isNaN(event.target.value)) event.target.value = '';
        if(event.target.value.length > 4) event.target.value = event.target.value.substring(0, 4);
      },
      //**********************************************************
      async showChange(tire){
        this.loading = true;
        this.changeOrder.branch = this.currBranch == "*" ? this.branches[0]._id : this.currBranch;
        this.changeOrder.product = tire._id;
        this.changeOrder.productName = `${tire.brand} ${tire.size} ${tire.pattern}`;
        this.changeOrder.amount = 0;
        this.changeOrder.prod_date = '';
        this.loading = false;
        $('#changeModal').modal('show');
        this.branchChangedChangeOrder();
      },
      //**********************************************************
      async branchChangedChangeOrder(){
        this.loading = true;
        this.changeOrder.quantities = [];
        var ack = await this.$service.getStockDetails({
          branch: this.changeOrder.branch,
          product: this.changeOrder.product,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.changeOrder.quantities = ack.data;
          this.changeOrder.prod_date = ''
          this.changeOrder.amount = 0;
          if(this.changeOrder.quantities.length){
            this.changeOrder.prod_date = this.changeOrder.quantities[0].prod_date;
          }
        }
        this.loading = false;
      },

      //**********************************************************
      async changeAction(){
        this.loading = true;
        await this._changeAction();
        this.loading = false;
      },
      //**********************************************************
      async _changeAction(){
        if(!this.changeOrder.branch){
          return this.$toast('Select a branch', 'warning');
        }
        if(!this.changeOrder.prod_date){
          return this.$toast('Enter production date', 'warning');
        }
        if(this.changeOrder.amount < 0){
          return this.$toast('invalid amount', 'warning');
        }
        var ack = await this.$service.changeStock({
          branch: this.changeOrder.branch,
          product: this.changeOrder.product,
          prod_date: this.changeOrder.prod_date,
          amount: parseInt(this.changeOrder.amount),
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#changeModal').modal('hide');
        this.$toast('Amount Changed', 'success');
        this.loadStocks();
      },      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
#stockDetailsPieChartContainer{
    width: 100% !important;
    height: 200px !important;
}
#stockDetailsPieChart{
    max-width: 100% !important;
    height: 200px !important;
}
</style>
  